import { ComponentChildren } from 'preact';
import { multiVariantStyles } from './themes/HeadingStyles.css';
export const headingElementTypes = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] as const;

type ElementType = (typeof headingElementTypes)[number];

type HeadingProps = {
  /**
   * Specifies the heading tag
   */
  as: ElementType;

  /**
   * Specifies text color. If set as "inherit", takes text color from its parent element.
   */
  variant?: 'primary' | 'secondary' | 'disabled' | 'inherit';

  /**
   * Specifies the font size and line height.
   */
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'inherit';

  /**
   * Specifies the header id
   */
  id?: string;

  /**
   * Specifies the children
   */
  children: ComponentChildren;
};

const headingsizeMap: { [headingType in ElementType]: string } = {
  h1: '2xl',
  h2: 'xl',
  h3: 'lg',
  h4: 'md',
  h5: 'sm',
  h6: 'xs'
};

export const sizeOptions = ['xs', 'sm', 'md', 'lg', 'xl', '2xl', 'inherit'];

export function Heading({ children, as, size, id, variant = 'primary' }: HeadingProps) {
  const Component = as;
  //@ts-ignore
  size = size ?? headingsizeMap[Component];
  const classes = multiVariantStyles({ size, variant });
  return (
    <Component className={classes} id={id}>
      {children}
    </Component>
  );
}
